import { BadgeV3, ColorOption } from '@cimplico/components';
import { EntityTypeEnum } from '../../types/entity';
import { formatMixedCase } from '../../utilities/formatting';

type WorkpaperProcedureTypeBadgeProps = {
    entityType?: EntityTypeEnum;
};

function WorkpaperProcedureTypeBadge({ entityType }: WorkpaperProcedureTypeBadgeProps): JSX.Element {
    let colour = '';

    switch (entityType) {
        case EntityTypeEnum.TRUST:
            colour = 'yellow';
            break;
        case EntityTypeEnum.SOLE_TRADER:
            colour = 'green';
            break;
        case EntityTypeEnum.COMPANY:
            colour = 'indigo';
            break;
        case EntityTypeEnum.PARTNERSHIP:
            colour = 'pink';
            break;
        default:
            colour = 'blue';
    }

    return <BadgeV3 color={colour as ColorOption} label={entityType ? formatMixedCase(entityType) : 'General'} rounded size="small" />;
}

export default WorkpaperProcedureTypeBadge;
